module.exports = __webpack_public_path__ + "static/media/alerte_orange.cd5da9c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/tunnel/components/@sharded/notifications/alerte_orange.svg
// module id = 546
// module chunks = 0